import React from 'react'
import { motion, useScroll, useTransform, useSpring } from 'framer-motion'

const ScrollIndicator = () => {
    const { scrollYProgress } = useScroll()

    // Smooth spring animation for the progress
    const smoothProgress = useSpring(scrollYProgress, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001
    })

    // Track height = 400px, thumb height = 90px, so max travel = 310px
    const thumbY = useTransform(smoothProgress, [0, 1], [0, 310])

    return (
        <>
            {/* Main Scroll Indicator Container */}
            <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 1, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="fixed right-6 lg:right-10 top-[30%] -translate-y-1/2 z-50 hidden md:flex flex-col items-center gap-4"
            >
                {/* Track Container with Glassmorphism */}
                <div className="relative group">
                    {/* Outer Glow on Hover */}
                    <div className="absolute -inset-4 bg-[#C21F2A]/0 group-hover:bg-[#C21F2A]/5 blur-2xl rounded-full transition-all duration-700" />

                    {/* Main Track */}
                    <div
                        className="relative w-[6px] h-[400px] rounded-full"
                        style={{
                            background: 'rgba(20, 23, 27, 0.8)',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(255, 255, 255, 0.05)',
                            boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.2)'
                        }}
                    >
                        {/* Sliding Thumb */}
                        <motion.div
                            className="absolute top-0"
                            style={{
                                y: thumbY,
                                width: '4px',
                                height: '90px',
                                background: '#3A3F46',
                                borderRadius: '999px',
                                boxShadow: 'none'
                            }}
                        />
                    </div>
                </div>
            </motion.div>

            {/* Styles for custom scrollbar (optional enhancement) */}

        </>
    )
}

export default ScrollIndicator
